/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-02 17:27:05
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@root/components/Button';
import './index.less';
import SafeAreaInset from '@root/components/SafeAreaInset';
import PayMethod from '../PayMethod';
import useGiftCardPayMethod from '@root/hooks/giftCard/usePayMethod';

const GiftCardPayMethod = () => {
  const { t } = useTranslation();
  const {
    state: { paying, payMethodState },
    action: { onClickPay },
  } = useGiftCardPayMethod();

  return (
    <>
      <div className="flex-section-auto navbar-spacing">
        <PayMethod {...payMethodState}></PayMethod>
      </div>
      <div className="flex-section-footer">
        <Button loading={paying} onClick={onClickPay}>
          {t('purchase_now')}
        </Button>
        <SafeAreaInset />
      </div>
    </>
  );
};

export default GiftCardPayMethod;
